<div *ngIf="isLoading; then showLoading; else showContent"></div>
<ng-template #showLoading>
  <div class="card text-center">
    <div class="card-body" style="min-height: 150px">
      <div
        style="margin-top: 45px"
        class="spinner-border text-primary"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #showContent>
  <!-- discount modal -->
  <ng-template #discountModal let-modal>
    <div class="d-flex align-items-center justify-content-center mt-1">
      <h4 class="mb-0 ml-auto mr-auto text-black">Apply Discount</h4>
      <button
        type="button"
        class="close mr-1"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <hr class="my-0" />
    <div class="modal-body mb-2">
      <form [formGroup]="discountForm" (ngSubmit)="applyDiscount(modal)">
        <div class="form-group">
          <label for="discountCode" class="text-dark">Discount Code</label>
          <div class="input-group">
            <input
              type="text"
              id="discountCode"
              formControlName="discountCode"
              class="form-control"
              placeholder="Discount Code"
            />
            <div class="input-group-append">
              <button class="btn btn-primary" type="submit">Apply</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-template>
  <!-- end -->

  <div class="row">
    <div class="col-12">
      <div *ngIf="!alertClose && submitted">
        <ngb-alert [type]="'danger'" (closed)="alertClose = !alertClose">
          <div class="alert-body">
            Click on a subscription plan to select it.
            <button type="button" class="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </ngb-alert>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="upgrade" [ngClass]="plans.length > 1 ? 'upgrade' : 'beewiz-flex'">
        <ng-container *ngIf="plans?.length">
          <div *ngFor="let plan of plans; let index = index">
            <div
              class="card plan-card mb-0 border mt-md-1 cursor: pointer"
              [ngClass]="{
                'border-danger': !alertClose && submitted,
                'border-grey': alertClose,
                'border-success': index == selectedPlanIndex
              }"
            >
              <div class="card-body p-sm-10" (click)="setSelectedPlan(index)">
                <div class="mother-container d-flex align-items-start">
                  <input
                    style="flex-grow: 1"
                    class="mr-2"
                    type="radio"
                    id="customRadio_{{ plan.planId }}"
                    [value]="index"
                    (click)="setSelectedPlan(index)"
                    name="customRadio"
                    [checked]="selectedPlanIndex == index"
                    style="scale: 1.6"
                  />
                  <div class="text-container">
                    <label
                      style="cursor: pointer; width: 100%"
                      for="customRadio_{{ plan.planId }}"
                    >
                      <ng-container>
                        <h3 class="font-medium-3 text-black">
                          {{ plan.planName }}
                        </h3>
                        <div class="row justify-content-between align-items-center mr-2">
                          <h3 class="font-medium-5 text-muted strike-through ml-1" *ngIf="plan.discountedAmount < plan.amount">
                            KES {{ plan.amount | currency : "" : "" }}
                          </h3>
                          <h3 class="font-medium-5 text-primary ml-1">
                            KES {{ plan.discountedAmount | currency : "" : "" }}
                          </h3>
                        </div>
                      </ng-container>
                    </label>
                    <ng-container *ngIf="plans.length > 1; else checkCbcOrBeewiz">
                      <div class="plan-addons">
                        <p>This plan includes:</p>
                        <div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-1">
                          <h4 class="mb-0"> {{ plan.planName == ('Monthly plan') ? '1 month validity' : plan.planName == ('Weekly plan') ? '1 week validity' : plan.planName == ('Daily plan') ? '1 day validity' : plan.planName == ('Holiday plan') ? 'Entire Holiday' : plan.planName == ('3 Day Offer') ? '3 day validity' : '' }} </h4>
                        </div>
                        <div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-1">
                          <h4 class="mb-0">Quizzes</h4>
                        </div><div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-1">
                          <h4 class="mb-0">Video lessons</h4>
                        </div><div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-1">
                          <h4 class="mb-0">Unlimited contests</h4>
                        </div><div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-1">
                          <h4 class="mb-0">KCSE Practicals</h4>
                        </div><div class="d-flex align-items-center">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-1">
                          <h4 class="mb-0">KCSE Marking schemes</h4>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #checkCbcOrBeewiz>
                      <ng-container *ngIf="plans[0].educationSystem === 'CBC'; else showBeewizAddons">
                        <div class="plan-addons">
                        <p>This plan includes:</p>
                        <div class="d-flex flex-column flex-md-row">
                        <div>
                        <div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-50">
                          <h5 class="mb-0">2 months validity</h5>
                        </div>
                        <div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-50">
                          <h5 class="mb-0">Gamified Quizzes</h5>
                        </div><div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-50">
                          <h5 class="mb-0 mr-0 mr-md-2">Revision before school reopens</h5>
                        </div>
                        </div>

                        <div>
                        <div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-50">
                          <h5 class="mb-0">All strands & substrands unlocked</h5>
                        </div>
                        <div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-50">
                          <h5 class="mb-0">CBC Video lessons</h5>
                        </div>
                        <div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-50">
                          <h5 class="mb-0">After-school practice in January</h5>
                        </div>
                        </div>
                        </div>
                      </div>
                      </ng-container>
                      <ng-template #showBeewizAddons>
                        <div class="plan-addons">
                        <p>This plan includes:</p>
                        <div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-1">
                          <h4 class="mb-0">3 months validity</h4>
                        </div>
                        <div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-1">
                          <h4 class="mb-0">5 Contests</h4>
                        </div><div class="d-flex align-items-center mb-1">
                          <img src="../../../../../../assets/img/Group 1000001759.png" height="28px" alt="" class="mr-1">
                          <h4 class="mb-0">Invite as many friends as you can</h4>
                        </div>
                      </div>
                      </ng-template>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <!-- start careersplan -->
  <ng-container *ngIf="careerPlans?.courses?.length">
    <div class="row form-group">
      <div class="col-md-4">
        <label class="form-label fs-sm-16">Course Topic </label>
      </div>

      <div class="col-md-8">
        <ng-select
          [items]="unpaidCareerTopics"
          bindLabel="title"
          name="selectedPlanIndex"
          [(ngModel)]="selectedPlanIndex"
        >
        </ng-select>
      </div>
    </div>
  </ng-container>
  <!-- end careersplan -->
  <form
    [formGroup]="phoneForm"
    class="fs-sm-16 mt-md-1"
    (ngSubmit)="submitPhoneNumber()"
  >
    <div class="form-group">
      <label class="fs-sm-16 text-black">Payment Source</label>
      <select class="form-control fs-sm-16">
        <option value="null" disabled selected>M-PESA</option>
      </select>
    </div>

    <div class="form-group">
      <label class="fs-sm-16 text-black">Phone Number</label>
      <input
        formControlName="phone"
        type="text"
        class="form-control fs-sm-16"
        [ngClass]="{ error: submitted && f.phone.invalid }"
        placeholder="Mpesa Number"
        name="phone_number"
      />
      <div class="text-danger" *ngIf="submitted && f.phone.errors">
        <p class="mb-0" *ngIf="f.phone.errors?.required">
          This field is required
        </p>
        <p
          class="mb-0"
          *ngIf="
            f.phone.errors?.minlength ||
            f.phone.errors?.maxlength ||
            f.phone.errors?.pattern
          "
        >
          Provide valid phone number
        </p>
      </div>
    </div>

    <div
      class="d-flex align-items-end cursor-pointer mb-3"
      (click)="openDiscountModal()"
    >
      <img src="../../../../../../assets/img/plus.svg" alt="" />
      <p class="text-black mb-0">Add Discount Code</p>
    </div>

    <div class="mb-0 mt-md-2">
      <button
        class="btn btn-primary btn-md btn-block font-weight-bolder waves-effect waves-light mb-1"
      >
        Make Payment
      </button>
      <button
        (click)="loadHomepage()"
        class="btn btn-outline-danger btn-md btn-block font-weight-bolder"
      >
        Cancel
      </button>
    </div>

    <!-- <div
      class="form-group mb-0 mt-md-2"
      style="display: flex; justify-content: space-between"
    >
      <button (click)="loadHomepage()" class="btn btn-outline-danger fs-sm-16 border-0">
        Cancel
      </button>
      <button class="btn btn-primary btn-small-padding fs-sm-16">
        Make Payment
      </button>
    </div> -->
  </form>
</ng-template>

<!--<form class="row" [formGroup]="planForm" (ngSubmit)="submitPlan()">-->
<!--    <div class="col-sm-12">-->
<!--        <div class="form-group">-->
<!--            <label for="plan">Select Subscription Plan</label>-->
<!--            <select formControlName="plan" id="plan" class="form-control"-->
<!--                    [ngClass]="{'is-invalid':submitted && f.plan.invalid}">-->
<!--                <option value="">Select Plan</option>-->
<!--                <option *ngFor="let plan of plans;index as index" [value]="index"> {{plan.planName}}</option>-->
<!--            </select>-->
<!--            <div class="text-danger" *ngIf="submitted && f.plan.invalid">-->
<!--                <p class="mb-0" *ngIf="f.plan?.errors?.required">Select a subscription plan</p>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="form-group d-flex justify-content-between">-->
<!--            <button class="btn btn-outline-primary waves-effect waves-light" type="button" (click)="loadHomepage()">-->
<!--                Cancel-->
<!--            </button>-->
<!--            <button class="btn btn-primary waves-effect waves-light" type="submit">Next <i-->
<!--                    class="fa fa-arrow-right"></i></button>-->
<!--        </div>-->
<!--    </div>-->
<!--</form>-->
